// new code
import {
  AfterViewInit,
  Component,
  ViewChild,
  OnInit,
  Inject,
  ElementRef,
  Input,
} from '@angular/core';
import { Router } from '@angular/router';
import { ChangeDetectorRef } from '@angular/core';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { MatDialog } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { WindowUtils } from 'msal';
import { DomSanitizer } from '@angular/platform-browser';
// new code end
import {
  Gallery,
  GalleryItem,
  ThumbnailsPosition,
  ImageSize,
  ImageItem,
} from 'ng-gallery';

@Component({
  selector: 'app-discussion-board-details',
  templateUrl: './discussion-board-details.component.html',
  styleUrls: ['./discussion-board-details.component.scss'],
})
export class DiscussionBoardDetailsComponent implements OnInit {
  postanswer: FormGroup;
  postnewanswer: FormGroup;
  // Answer;
  response;
  data: any;
  view = '';
  like = '';
  totalAnswer = '';
  postedBy = '';
  role = '';
  postedDat;
  resultdata;
  avtar = false;
  result;
  isShown: boolean = false;
  buttonAction: string = 'Close';
  userName: string = localStorage.getItem('UserName');
  Answer: string = '';
  updatedAnswerId: string = '';
  isImage: boolean = false;

  // selectedoption: string;
  editNews = false;
  editanswer = false;
  imagePath: any;
  videopath: any;
  constructor(
    private router: Router,
    public dialog: MatDialog,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private _sanitizer: DomSanitizer
  ) {}
  askquestionform: FormGroup;
  ngOnInit(): void {
    // this.showDocument(this.id_data);
    // edit form
    // this.askquestionform = this.fb.group({
    //   questionTitle: ['', [Validators.required]],
    //   quetionDiscription: ['', [Validators.required]],
    //   attachlink: ['', [Validators.pattern(this.reg)]],
    //   Image: ['', [Validators.required]],
    // });
    this.askquestionform = this.fb.group({
      // questionTitle: ['', [Validators.minLength(20),Validators.maxLength(60)]],
      questionTitle: ['', [Validators.minLength(20), Validators.maxLength(60)]],
      quetionDiscription: [
        '',
        [Validators.required, Validators.maxLength(400)],
      ],
      // attachlink: ['', [Validators.pattern(this.reg)]],
      Image: ['', [Validators.required]],
    });

    this.getAlluser();
    this.postanswer = this.fb.group({
      title: ['', [Validators.required]],
      discription: ['', [Validators.required]],
      uploadedFile: ['', [Validators.required]],
    });

    // new code

    // second form
    this.postnewanswer = this.fb.group({
      Answer: ['', [Validators.required]],
    });
    var postdata = {
      // "postId": this.data.name,
      postId: localStorage.getItem('postId'),
    };
    this._userService.getViewPostDetail(postdata).subscribe((data) => {
      this.userlist = this.userdata.result.data;
      this.userlist1 = this.userdata.result.data.answers;
    });
  }
  get questionTitle() {
    return this.askquestionform.get('questionTitle');
  }

  get quetionDiscription() {
    return this.askquestionform.get('quetionDiscription');
  }

  guidelinePage() {
    this.router.navigate(['/discussionboard-guidelines']);
  }
  toggleShow() {
    this.isShown = !this.isShown;
  }

  removeFile() {
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }
  // new code
  onPostnewanswer(id: string) {
    this.spinner.show();
    localStorage.getItem('postId');

    // let myfile = this.finaldata
    if (this.postnewanswer.status == 'INVALID') {
      alert('Please fill all mandatory fields and enter valid values');
    } else {
      const postdata = new FormData();
      postdata.append('Answer', this.postnewanswer.value.Answer);
      if (this.postnewanswer.value.Answer == '') {
        alert('Please Enter Mandatory fields');
      } else {
        let text = confirm(
          'Are you sure you want to publish this new answer ?'
        );
        if (text == true) {
          postdata.append('Answer', this.postnewanswer.value.Answer);
          postdata.append('postId', localStorage.getItem('postId'));
          this._userService.postNewanswer(postdata).subscribe((data) => {
            this.response = data;
            this.spinner.hide();
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
          });
          // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          //   this.router.navigate(['/Govt-schemes']);
          // });
        } else {
          //  return false;
        }
      }
    }
    this.spinner.hide();
    window.location.reload();
  }

  // new code end

  listPage() {
    this.router.navigate(['/discussionboard']);
    // window.location.reload();
  }
  listPage1() {
    this.getAlluser();
    this.editNews = false;
    // this.editanswer=false;

    this.router.navigate(['discussionboard-details']);
    // window.location.reload();
  }
  // close answer code with remark popup
  /*model pop up for delete same page  */
  // openDialog(data): void {
  openCloseQuestionpopup(): void {
    // this.selectedoption='close';

    const dialogRef = this.dialog.open(CloseQuestionpopup, {
      // width: '30%',
      // height: '30%',
      // data: { id: data }
    });
    // this.selectedoption='close';
    dialogRef.afterClosed().subscribe((result) => {
      // this.applyfilter(false) ;
      // this.getCount();
    });
  }
  openCloseQuestionpopup1(id: any): void {
    // this.selectedoption='close';
    localStorage.setItem('answerId', id);
    const dialogRef = this.dialog.open(CloseQuestionpopup, {
      // width: '30%',
      // height: '30%',
      // data: { id: data }
    });
    // this.selectedoption='close';
    dialogRef.afterClosed().subscribe((result) => {
      // this.applyfilter(false) ;
      // this.getCount();
    });
  }

  openPutBackpopup(): void {
    // this.selectedoption='close';
    const dialogRef = this.dialog.open(PutBackpopup, {
      // width: '30%',
      // height: '30%',
      // data: { id: data }
    });
    // this.selectedoption='close';
    dialogRef.afterClosed().subscribe((result) => {
      // this.applyfilter(false) ;
      // this.getCount();
    });
  }

  openPutBackpopup1(id: any): void {
    localStorage.setItem('answerId', id);
    // this.selectedoption='close';
    const dialogRef = this.dialog.open(PutBackpopup, {
      // width: '30%',
      // height: '30%',
      // data: { id: data }
    });
    // this.selectedoption='close';
    dialogRef.afterClosed().subscribe((result) => {
      // this.applyfilter(false) ;
      // this.getCount();
    });
  }

  openRemovepopup(): void {
    // this.selectedoption='close';
    const dialogRef = this.dialog.open(Removepopup, {
      // width: '30%',
      // height: '30%',
      // data: { id: data }
    });
    // this.selectedoption='close';
    dialogRef.afterClosed().subscribe((result) => {
      // this.applyfilter(false) ;
      // this.getCount();
    });
  }
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  toggleVideo(event: any) {
    this.videoplayer.nativeElement.play();
  }
  imageOrVideopath: boolean = false;
  userlist;
  userdata;
  userlist1;
  // isImage:boolean=false;
  isVideo: boolean = false;
  getAlluser() {
    this.spinner.show();
    var postdata = {
      postId: localStorage.getItem('postId'),
      //"67AC24F3-4043-4131-ACA1-173CC473031C"
    };
    this._userService.getViewPostDetail(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data;
      if (this.userlist.fileType === 'Image' && this.userlist.postFile != '') {
        this.isImage = true;
        // this.isImage=true;
        this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
          `data:image/png;base64,${this.userlist.postFile}`
        );
      } else if (this.userlist.fileType === 'Video') {
        this.isVideo = true;
        // this.isVideo=true;
        this.videopath = this._sanitizer.bypassSecurityTrustResourceUrl(
          `data:video/mp4;base64,${this.userlist.postFile}`
        );
      }
      // else if(this.userlist.fileType===""){
      //   this.imageOrVideopath=false;
      //   // this.isVideo=true;
      //   // this.videopath =this._sanitizer.bypassSecurityTrustResourceUrl(`data:video/mp4;base64,${this.userlist.postFile}`);
      // }

      this.userlist1 = this.userdata.result.data.answers;

      // this.userlist = this.userdata.data;
      this.spinner.hide();

      // this.spinner.hide();
    });
    // this.spinner.hide();
  }

  // post your answer
  onSubmit() {
    if (this.postanswer.valid) {
      var postdata = {
        description: this.postanswer.value.description,
        uploadedFile: this.postanswer.value.uploadedFile,
      };
      this._userService.postCreatequestion(postdata).subscribe((data) => {
        this.response = data;
        // window.location.reload();

        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }

  //edit row fuctionality //
  fileData;
  finaldata;
  lastFilePath: any;
  file1: any;
  isButtonVisible = false;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  savescheme = false;
  processImage1(event) {
    this.isButtonVisible = true;
    // let files: FileList = event.target.files;
    // this.file1  = files[0];
    let splitfile = event.target.files[0].type;
    let type = splitfile.split('/');

    if (
      type[1] == 'jpeg' ||
      type[1] == 'jpg' ||
      type[1] == 'png' ||
      type[1] == 'pdf'
    ) {
      this.finaldata = this.file1;
      //this.file2 = this.file1;
      this.savescheme = true;
    }
    // else {
    //   this.finaldata = 0;
    //   this.myInputVariable.nativeElement.value = "";
    //   this.savescheme = false;
    //   this.isButtonVisible = false;
    //   this.toastr.warning("Accepted File Formats PDF,PNG.JPG and JPEG only", 'Info', {
    //     timeOut: 3000,
    //   });
    //   //this.file2 = null;
    //   return;
    // }

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: FileList = event.target.files;
    this.file1 = files[0];
    const fileSize = Math.round(this.file1.size / 1024);
    if (fileSize > 5120) {
      // if (this.file1.size >= 4096) {
      this.myInputVariable.nativeElement.value = '';
      this.askquestionform.value.Image = '';
      this.toastr.warning('Accepted  file Size should be below 5MB', 'Info', {
        timeOut: 3000,
      });
    } else {
      this.finaldata = this.file1;
      this.savescheme = true;
    }
  }
  // delet answer
  deleteAnswer(answerId: any) {
    if (confirm('Are you sure you want to delete this answer?')) {
      // Save it!
      var postdata = {
        answerId: answerId,
      };
      localStorage.removeItem('answerId');
      this._userService.deleteDBAnswer(postdata).subscribe((data) => {
        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
      });

      this.isShown = true;
      window.location.reload();
    } else {
      // Do nothing!
      this.router.navigate(['discussionboard-details']);
    }
  }

  // delete post

  deletePost() {
    if (confirm('Are you sure you want to delete this post?')) {
      // Save it!
      var postdata = {
        postId: localStorage.getItem('postId'),
      };
      this._userService.deleteDBPost(postdata).subscribe((data) => {
        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        // this.dialogRef.close();
      });
      // this.router.navigate(['/discussionboard']);
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/discussionboard']);
      });
    } else {
      // Do nothing!
      this.router.navigate(['/discussionboard-details']);
    }
    // window.location.reload();
  }
  // edit answer
  editAnswer(answerId: any) {
    this.updatedAnswerId = answerId;
    this.userlist1.forEach((user) => {
      if (user.answerId === answerId) {
        this.Answer = user.answer;
        return;
      }
    });
    this.postnewanswer.get('Answer').setValue(this.Answer);
    this.editanswer = true;
  }

  onUpdateAnswer() {
    if (confirm('Are you sure you want to update this answer?')) {
      var postdata = {
        answerId: this.updatedAnswerId,
        answer: this.postnewanswer.value.Answer,
      };
      this._userService.updateDBAnswer(postdata).subscribe((data) => {
        this.response = data;
        this.spinner.hide();
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
      });
      this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/discussionboard-details']);
      });
      window.location.reload();
    } else {
      this.router.navigate(['/discussionboard-details']);
      // window.location.reload();
    }

    // this.askquestionform.reset();
    this.spinner.hide();
  }
  // edit answer end

  // govnt edit refered
  attachfile;
  edit(readdata) {
    this.editNews = true;
    var postdata = {
      postId: localStorage.getItem('postId'),
    };

    this._userService.getViewPostDetail(postdata).subscribe((data) => {
      this.userlist = data;
      this.userlist1 = this.userlist.result.data;
    });
    this.askquestionform.get('questionTitle').setValue(readdata.question);
    this.askquestionform
      .get('quetionDiscription')
      .setValue(readdata.description);
    this.askquestionform.get('Image').setValue(readdata.postFile);
    // this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'
    //              + readdata.postFile.base64string);
    if (this.userlist1.fileType === 'Image') {
      this.imageOrVideopath = true;
      // this.isImage=true;
      this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl(
        `data:image/png;base64,${this.userlist.postFile}`
      );
    } else if (this.userlist1.fileType === 'Video') {
      this.imageOrVideopath = false;
      // this.isVideo=true;
      this.videopath = this._sanitizer.bypassSecurityTrustResourceUrl(
        `data:video/mp4;base64,${this.userlist.postFile}`
      );
    }
    // this.imagePath =this._sanitizer.bypassSecurityTrustResourceUrl(`data:application/pdf;base64,${readdata.postFile}`);
    // this.videopath =this._sanitizer.bypassSecurityTrustResourceUrl(`data:video/mp4;base64,${this.userlist.postFile}`);
  }

  onSubmit1() {
    let myfile = this.finaldata;

    if (
      this.askquestionform.value.questionTitle === '' &&
      this.askquestionform.value.Image === ''
    ) {
      alert('Please fill all mandatory fields and enter valid values');
      return;
    } else if (this.askquestionform.value.questionTitle === '') {
      alert('Please enter the title');
      return;
    }
    //  else if(this.askquestionform.value.Image==="") {
    //   alert('Please choose an image file should be less than 5MB')
    // return;
    //  }
    else if (
      this.askquestionform.value.questionTitle == '' ||
      this.askquestionform.value.quetionDiscription == '' ||
      this.askquestionform.value.questionTitle === null ||
      this.askquestionform.value.quetionDiscription === null
    ) {
      alert('Please Enter Mandatory fields');
    } else {
      const postdata = new FormData();
      // postdata.append('Title', this.askquestionform.value.questionTitle);
      // postdata.append('PostId', localStorage.getItem("postId"));
      //postdata.append('question', this.askquestionform.value.questionTitle);
      let text = confirm('Are you sure you want to update this Post ?');
      if (text == true) {
        this.spinner.show();
        // postdata.append('description', this.askquestionform.value.quetionDiscription);
        //postdata.append('Image', this.finaldata);
        postdata.append('PostId', localStorage.getItem('postId'));
        postdata.append('Title', this.askquestionform.value.questionTitle);
        postdata.append('Image', this.finaldata);
        postdata.append(
          'Content',
          this.askquestionform.value.quetionDiscription
        );
        this._userService.updateDBPost(postdata).subscribe((data) => {
          this.response = data;
          this.spinner.hide();
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
          this.router
            .navigateByUrl('', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/discussionboard-details']);
            });
        });
        // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
        //   this.router.navigate(['/discussionboard-details']);
        // });
      } else {
        //  return false;
      }
      // }
    }
    // window.location.reload();

    // this.askquestionform.reset();
    this.spinner.hide();
  }
  //  govnt edit refered end
  // bese64 string convertion
  filterDocuments;
  showurl;
  filterdocumentfrombase64;
  items: GalleryItem[];
  documentlist = [];
  inprogress = false;
  rejected = false;
  listurl = [];
  base64;
  companyname;
  documentStatus;
  mandi;
  personName;
  phoneNo;
  states;
  imageSource;
  soure;
  items1;
  imgshow;
  TraderId;
  id_data;
  showurldata;
  showtext;
  items_url;
  items_find_url;
  iddocument;
  base123;
  test;
  pdfprint;
  pdfurl;
  pdfdata;
  filetype;
  filetypereal;
  address;
  emailId;
  rejectedReason;
  showDocument(data) {
    // this.docDetails = true;
    // this.showinput = false;
    // this.documentbutton = false;
    this.spinner.show();
    setTimeout(() => {
      // this.selectedIndex = 3;
      this.spinner.hide();
    }, 6000);

    this.filterDocuments = data;
    this.id_data = data.personId;
    if (this.filterDocuments.docuements != null) {
      // if (this.filterDocuments.docuements.length == 0)
      // {
      //   alert("There is no document uploaded under this trader")
      //   this.spinner.hide()
      // }
      // else {

      // this.companyname = data.company
      // this.documentStatus = data.adminStatus
      // this.mandi = data.mandi
      // this.personName = data.personName
      // this.phoneNo = data.phoneNo
      // this.role = data.role
      // this.states = data.states
      // this.address = data.address
      // this.emailId = data.emailId
      // this.TraderId = data.personId
      // this.district = data.district
      // this.rejectedReason = data.rejectedReason

      // if (this.documentStatus == "InProgress") {
      //   this.inprogress = true
      // }
      // else if (this.documentStatus == "InProgress") {
      //   this.rejected = true
      // }
      this.filterDocuments = data;
      this.documentlist = this.filterDocuments.docuements;
      var postdata = {
        postId: localStorage.getItem('postId'),
      };

      this._userService.getViewPostDetail(postdata).subscribe((dcumentdata) => {
        // this.showDocument(data);
        setTimeout(() => {
          // this.filtershow = false;
          // this.selectedIndex = 3;
          this.base64 = dcumentdata;
          this.listurl = this.base64.result.data;
          this.filetype = this.listurl.map(
            (item) => new ImageItem({ src: item.postFile })
          );
          this.filetype.forEach((element) => {
            this.filetypereal = element.data.src;
          });
          this.pdfdata = this.listurl.map(
            (item) =>
              new ImageItem(
                this._sanitizer.bypassSecurityTrustResourceUrl(
                  `data:application/pdf;base64,${item.postFile}`
                )
              )
          );
          this.pdfprint = this.pdfdata.map(
            (item) =>
              new ImageItem({
                src: item.data.changingThisBreaksApplicationSecurity,
              })
          );
          this.items_url = this.listurl.map(
            (item) =>
              new ImageItem(
                this._sanitizer.bypassSecurityTrustResourceUrl(
                  `data:image/png;base64,${item.postFile}`
                )
              )
          );
          this.items_find_url = this.items_url.map(
            (item) =>
              new ImageItem({
                src: item.data.changingThisBreaksApplicationSecurity,
              })
          );
        });
      });
      // }
    }
  }
  // base 64 convertion end
}

/* ===========================================close-pop-up==============================================================*/
@Component({
  selector: 'close-pop-up',
  templateUrl: 'close-pop-up.html',
})
export class CloseQuestionpopup {
  profileForm = new FormGroup({
    remark: new FormControl(''),
  });
  // profileForm: FormGroup;

  response;
  // selectedoption='';
  isShown: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<CloseQuestionpopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    localStorage.removeItem('answerId');
    this.dialogRef.close();
  }
  closeform: FormGroup;
  ngOnInit(): void {
    this.closeform = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.closeform.valid) {
      var postdata = {
        postId: localStorage.getItem('postId'),
        remark: this.closeform.value.Remark,
        answerId:
          localStorage.getItem('answerId') === null
            ? ''
            : localStorage.getItem('answerId'),
        isClose: true,
      };
      localStorage.removeItem('answerId');
      this._userService.closeAnswer(postdata).subscribe((data) => {
        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.isShown = true;
        this.dialogRef.close();
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
    //   this.router.navigateByUrl('/discussionboard-details', { skipLocationChange: true }).then(() => {
    //     this.router.navigate(['/discussionboard-details']);
    // });
    window.location.reload();
  }
}

/* ===========================================Put Back-pop-up==============================================================*/
@Component({
  selector: 'putback-pop-up',
  templateUrl: 'putback-pop-up.html',
})
export class PutBackpopup {
  response;
  // selectedoption='';

  constructor(
    public dialogRef: MatDialogRef<PutBackpopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    localStorage.removeItem('answerId');
    this.dialogRef.close();
  }
  putbackform: FormGroup;
  remarkinfo;
  // @Input() selectedoption: string;
  ngOnInit(): void {
    this.putbackform = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.putbackform.valid) {
      // if (this.remarkinfo!="") {
      var postdata = {
        // "postId":  localStorage.getItem("postId"),
        // "remark": this.putbackform.value.Remark,
        // "answerId": "",
        // "isClose": 0,
        postId: localStorage.getItem('postId'),
        remark: this.putbackform.value.Remark,
        answerId:
          localStorage.getItem('answerId') === null
            ? ''
            : localStorage.getItem('answerId'),
        isClose: false,
      };
      localStorage.removeItem('answerId');
      this._userService.closeAnswer(postdata).subscribe((data) => {
        this.response = data;
        // window.location.reload();

        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
      // this.router.navigateByUrl('', { skipLocationChange:  true }).then(() => {
      //   this.router.navigate(['/Govt-schemes-list']);
      //   // this.spinner.hide()
      // });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
    window.location.reload();
  }
}

/* ===========================================Remove-pop-up==============================================================*/
@Component({
  selector: 'remove-pop-up',
  templateUrl: 'remove-pop-up.html',
})
export class Removepopup {
  removeform: FormGroup;
  response;
  // selectedoption='';

  constructor(
    public dialogRef: MatDialogRef<Removepopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  // @Input() selectedoption: string;
  ngOnInit(): void {
    // this.selectedoption = 'John';
    this.removeform = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.removeform.valid) {
      var postdata = {
        postId: localStorage.getItem('postId'),
        remark: this.removeform.value.Remark,
        // "remark": "",
        answerId: '',
        isClose: 0,
      };
      this._userService.getViewPostDetail(postdata).subscribe((data) => {
        this.response = data;
        // window.location.reload();

        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
      // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/Govt-schemes-list']);
      //   // this.spinner.hide()
      // });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}
